import { all } from 'redux-saga/effects';

import { ActivityControllerSaga } from '@/controllers/Activity';
import { OpportunityControllerSaga } from '@/controllers/Opportunity';
import { CreateNewOrderSaga } from '@/controllers/Order';
import { ProposalControllerSaga } from '@/controllers/Proposals';
import { SiteSurveyControllerSaga } from '@/controllers/SiteSurvey';
import { FileControllerSaga } from '@/controllers/Uploads';

import { GeneralSaga } from './general';
import { GlobalApiSaga } from './global-api';
import { ShippingAddressesSaga } from './shipping-adresses-saga';

export function* rootSaga() {
  yield all([
    GeneralSaga(),
    GlobalApiSaga(),
    CreateNewOrderSaga(),
    ShippingAddressesSaga(),
    OpportunityControllerSaga(),
    FileControllerSaga(),
    ProposalControllerSaga(),
    SiteSurveyControllerSaga(),
    ActivityControllerSaga(),
  ]);
}
